import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-474b8400"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "commute-method-tags" }

import Tag from "@/components/atoms/other/Tag.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CommuteMethodTags',
  props: {
  canCommuteByCar: {
    type: Boolean,
    required: true
  },
  canCommuteByBike: {
    type: Boolean,
    required: true
  },
  canCommuteByBicycle: {
    type: Boolean,
    required: true
  },
  canCommuteByPublicTransit: {
    type: Boolean,
    required: true
  }
},
  setup(__props) {

const props = __props;


function getTagClass(isActive: boolean) {
  return isActive ? "tag-yellow" : "tag";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Tag, {
      label: "車",
      class: _normalizeClass(getTagClass(props.canCommuteByCar))
    }, null, 8, ["class"]),
    _createTextVNode(),
    _createVNode(Tag, {
      label: "バイク",
      class: _normalizeClass(getTagClass(props.canCommuteByBike))
    }, null, 8, ["class"]),
    _createTextVNode(),
    _createVNode(Tag, {
      label: "自転車",
      class: _normalizeClass(getTagClass(props.canCommuteByBicycle))
    }, null, 8, ["class"]),
    _createTextVNode(),
    _createVNode(Tag, {
      label: "電車",
      class: _normalizeClass(getTagClass(props.canCommuteByPublicTransit))
    }, null, 8, ["class"]),
    _createTextVNode(),
    _createVNode(Tag, {
      label: "バス",
      class: _normalizeClass(getTagClass(props.canCommuteByPublicTransit))
    }, null, 8, ["class"]),
    _createTextVNode(),
    _createVNode(Tag, {
      label: "徒歩",
      class: _normalizeClass(getTagClass(props.canCommuteByPublicTransit))
    }, null, 8, ["class"])
  ]))
}
}

})